var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarouselArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6425 9.36371L19.3333 16.0001L13.6425 22.6362C13.1705 23.1611 13.2479 23.9424 13.8132 24.3794C14.0626 24.5726 14.3652 24.6667 14.6666 24.6667C15.0479 24.6667 15.4266 24.5144 15.6906 24.2209L22.3573 16.7923C22.4093 16.7341 22.436 16.666 22.4747 16.6017C22.5067 16.5497 22.5453 16.5051 22.5693 16.4481C22.6293 16.3058 22.6653 16.1559 22.6653 16.0049L22.6667 15.9999L22.6653 15.995C22.6653 15.8439 22.6293 15.6941 22.5693 15.5518C22.5453 15.4948 22.5067 15.4502 22.4747 15.3982C22.436 15.3338 22.4093 15.2657 22.3573 15.2076L15.6906 7.77894C15.2199 7.25398 14.3799 7.18217 13.8132 7.62046C13.2479 8.05751 13.1705 8.83876 13.6425 9.36371Z",
    fill: "#B0B3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrow);
export default __webpack_public_path__ + "static/media/carouselArrow.021dc4378599e128c82c34dd671f4725.svg";
export { ForwardRef as ReactComponent };